import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQS = [
  {
    q: "What's included in the $249 chimney sweep special?",
    a: "A complete professional chimney sweeping plus a free visual inspection of your chimney, flue, crown, cap, and flashing. If we spot any issues, we'll show you exactly what we found and give you an honest, no-pressure quote for repairs.",
  },
  {
    q: "How often should I have my chimney swept?",
    a: "The National Fire Protection Association recommends an annual inspection, with sweeping as needed. If you burn wood regularly through an Oregon winter, a yearly sweep keeps creosote — the leading cause of chimney fires — under control.",
  },
  {
    q: "How long does a sweep and inspection take?",
    a: "Most appointments take 60 to 90 minutes. We protect your floors and hearth area, and we leave your home as clean as we found it — no soot, no mess.",
  },
  {
    q: "What are signs my chimney needs repair?",
    a: "White staining on the brick (efflorescence), crumbling mortar joints, a cracked crown, rust on the damper or firebox, water in the fireplace, or pieces of tile in the firebox. Any of these mean it's time for an inspection.",
  },
  {
    q: "What is tuckpointing and why does it matter?",
    a: "Tuckpointing replaces deteriorated mortar between bricks with fresh mortar. It restores the structural strength of your chimney and stops water from working its way into the masonry — far cheaper than rebuilding a chimney later.",
  },
  {
    q: "Which areas do you serve?",
    a: "We serve the greater Portland metro area, including Portland, Hillsboro, Clackamas, Beaverton, and Tualatin. Not sure if you're in our range? Call 971-255-3874 and we'll let you know right away.",
  },
];

export function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 lg:py-32 scroll-mt-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="mb-16"
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-primary mb-4">
            Common Questions
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl tracking-tight leading-tight font-bold text-foreground">
            Frequently Asked Questions
          </h2>
        </motion.div>
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-heading font-semibold text-foreground"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
